import { registrarPaginaDaVisita } from "@/utils/origemDaVisita";

/**
 * Guarda a origem da visita a cada página, só no cliente (OS Medição, item 6). O checkout manda
 * o que ficou guardado (utils/dadosDaVisita.ts), e o servidor grava junto com o pedido.
 */
export function useOrigemDaVisita() {
  if (import.meta.server) return;

  const route = useRoute();
  const registrar = () => {
    try {
      registrarPaginaDaVisita(route.query as Record<string, unknown>, route.path);
    } catch (_e) {
      // A origem nunca quebra a navegação
    }
  };

  onMounted(registrar);
  watch(() => route.fullPath, registrar);
}
